import * as React from "react";

interface Props {
  height?: number;
  width?: number;
}

const Diamond = ({ height = 800, width = 800, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.037 1.201 2.125 6.7a.48.48 0 0 0-.124.3q-.008.165.096.3l4.91 6.46c.055.074.13.135.215.177a.64.64 0 0 0 .556 0 .6.6 0 0 0 .216-.177l4.91-6.46a.45.45 0 0 0 .095-.3.48.48 0 0 0-.124-.3L7.963 1.201a.6.6 0 0 0-.208-.148.64.64 0 0 0-.718.148"
      fill="currentColor"
    />
  </svg>
);
export default Diamond;